import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ApiClient from '@/plugins/api-client'
import '@/assets/styles/index.scss'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import AutoTooltip from '@/components/AutoTooltip.vue';


import SearchForms from '@/components/searchComps/SearchForms.vue';

const app = createApp(App)

app.config.globalProperties.formatProductName = (value, list) => {
  return list.find(v=>v.value==value)?.label ?? value
}



// 检查版本变化
const currentVersion = '1.0.0'
const lastVersion = localStorage.getItem('app_version')
console.log('lastVersion', lastVersion)
console.log('currentVersion', currentVersion)
if (!lastVersion || lastVersion !== currentVersion) {
  // 版本变化时清除缓存
  if ('caches' in window) {
    caches.keys().then(cacheNames => {
      cacheNames.forEach(cacheName => caches.delete(cacheName))
    })
  }
  
  localStorage.setItem('app_version', currentVersion)
  window.location.reload()
}



app.component('SearchForms', SearchForms)
app.component('AutoTooltip', AutoTooltip);

app
.use(router).use(store).use(Antd)
.use(ApiClient)
.mount('#app')
